import React from 'react'
import { useTranslation } from 'lib/i18n'
import { RefinementListProvided } from 'react-instantsearch-core'
import { connectRefinementList } from 'react-instantsearch-dom'

import Checkbox from 'components/Filters/Checkbox'
import CheckboxList from 'components/Filters/CheckboxList'
import Hit from 'components/Filters/types/Hit'
import LocalizedRefinementItem from 'components/Filters/types/LocalizedRefinementItem'
import useLocalisedRefinementItems from 'components/Filters/useLocalisedRefinementItems'
import FilterTitle from 'components/UI/Filters/FilterTitle'
import FilterWrapper from 'components/UI/Filters/FilterWrapper'

const REVIEWS_LEVELS = [10, 20, 50]

const reviewsFrom = (number: number): LocalizedRefinementItem => ({
  key: number.toString(),
  label: (t) => t(`filter.reviews.label`, '{{number}}+ reviews', { number }),
})

const byNumberDesc = (a: Hit, b: Hit) => Number(b.label) - Number(a.label)

const CustomReviewsRefinementList = ({
  items,
  refine,
}: RefinementListProvided) => {
  const { t } = useTranslation()
  const { toLocalisedLabel } = useLocalisedRefinementItems(
    REVIEWS_LEVELS.map((level) => reviewsFrom(level)),
  )

  if (!items.length) {
    return null
  }

  return (
    <FilterWrapper>
      <FilterTitle title={t('filter.reviews.title', 'Number of reviews')} />
      <CheckboxList>
        {items
          .sort(byNumberDesc)
          .map(toLocalisedLabel)
          .map((item) => (
            <Checkbox key={item.label} item={item} refine={refine} />
          ))}
      </CheckboxList>
    </FilterWrapper>
  )
}

export default connectRefinementList(CustomReviewsRefinementList)
